import {
  ModelVersionENV,
  ModelVersionESS,
} from '@/domain/project/entities/project.entity';
import { ProjectMode } from '@/domain/project/project.slice';
import { ProjectFestival } from '@/domain/project-festival/entities/project-festival.entity';
import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import { ProjectVenue } from '@/domain/project-venue/entities/project-venue.entity';

export function getModelVersionENVForProject(
  projectMode: ProjectMode,
  currentProject: ProjectFestival | ProjectVenue | ProjectTour | null,
): ModelVersionENV {
  if (!currentProject) return '';
  if (projectMode === 'festival') {
    const castProject = currentProject as ProjectFestival;
    return castProject.models.env || '';
  } else if (projectMode === 'venue') {
    const castProject = currentProject as ProjectVenue;
    return castProject.models.structure.env || '';
  } else if (projectMode === 'tour') {
    const castProject = currentProject as ProjectTour;
    return castProject.models.env;
  } else {
    return '';
  }
}

export function getModelVersionESSForProject(
  projectMode: ProjectMode,
  currentProject: ProjectFestival | ProjectVenue | ProjectTour | null,
): ModelVersionESS {
  if (!currentProject) return '';
  if (projectMode === 'festival') {
    const castProject = currentProject as ProjectFestival;
    return castProject.models.ess || '';
  } else if (projectMode === 'venue') {
    const castProject = currentProject as ProjectVenue;
    return castProject.models.structure.ess || '';
  } else if (projectMode === 'tour') {
    const castProject = currentProject as ProjectTour;
    return castProject.models.ess;
  } else {
    return '';
  }
}
